import React, {forwardRef} from "react";
import footerLogo from "../../../assets/Logo/logo_white.png";
import iconInstagram from "../../../assets/Icon/kontak bawah/ic_ig.png";
import iconFacebook from "../../../assets/Icon/kontak bawah/ic_fb.png";
import iconTiktok from "../../../assets/Icon/kontak bawah/ic_tiktok.png";
import iconWeb from "../../../assets/Icon/kontak bawah/ic_web.png";
import iconEmail from "../../../assets/Icon/kontak bawah/ic_email.png";
import iconWhatsapp from "../../../assets/Icon/kontak bawah/ic_whatsapp.png";

const Footer = forwardRef<HTMLDivElement>((props, ref) => {
    return (
        <footer className="bg-black text-white py-6 px-4 md:px-12">
            <div ref={ref} className="flex flex-col md:flex-row justify-between gap-8 md:gap-12">
                {/* Left Section */}
                <div className="flex-1">
                    <div className="flex items-center mb-6">
                        <img src={footerLogo} alt="Life Media" className="h-12 mr-4" />
                    </div>
                    <div className="mb-6">
                        <h3 className="text-xl font-semibold font-poppins">Kantor Cabang:</h3>
                        <p className="text-sm font-poppins mt-4">
                            <b>Jakarta</b> - Jl. H. R. Rasuna Said No.Kavling B4, Kuningan, Karet Kuningan, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12910
                        </p>
                        <p className="text-sm font-poppins mt-4">
                            <b>Yogyakarta</b> - Jl. Parangtritis No.97, Brontokusuman, Kec. Mergangsan, Kota Yogyakarta, Daerah Istimewa Yogyakarta 55153
                        </p>
                        <p className="text-sm font-poppins mt-4">
                            <b>Surabaya</b> - Pakuwon Tower, Lt. 22 OT 18, Jl. Embong Malang No. 21-31,  Kedungdoro, Kec. Tegalsari, Surabaya, Jawa Timur 60261
                        </p>
                    </div>
                    <div className="mb-6">
                        <h3 className="text-xl font-semibold font-poppins">Kantor Operasional:</h3>
                        <p className="text-sm font-poppins mt-4">
                            <b>Jepara</b> - Jl. Jendral Ahmad Yani No.31, Pengkol VI, Pengkol, Kec. Jepara, Kabupaten Jepara, Jawa Tengah 59415
                        </p>
                        <p className="text-sm font-poppins mt-4">
                            <b>Sukoharjo</b> - Perum Tower Hunian Teduh Blok D No.1, Sawahan, Kudu, Kec. Baki, Kabupaten Sukoharjo, Jawa Tengah 57556
                        </p>
                    </div>
                </div>

                {/* Center Section */}
                <div className="flex-1">
                    <div className="md:mt-16 md:mx-24">
                        <h2 className="text-2xl font-semibold font-poppins">Hubungi Kami</h2>
                        <p className="flex items-center gap-2">
                            <a
                                href="https://mail.google.com/mail/?view=cm&fs=1&to=cs@lifemedia.id"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 text-white hover:text-blue-600 font-poppins"
                            >
                                <img
                                src={iconEmail}
                                alt="Icon Email"
                                className="w-6 h-6 rounded-full bg-white p-1"
                                />
                                cs@lifemedia.id
                            </a>
                        </p>
                        <p className="flex items-center gap-2 mt-2">
                            <a
                                href="https://api.whatsapp.com/send/?phone=%2B622746055655&text&type=phone_number&app_absent=0"
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center gap-2 text-white hover:underline font-poppins"
                            >
                                <img src={iconWhatsapp} alt="Icon Whatsapp" className="w-6 h-6 rounded-full bg-white p-1" />
                                (+62) 2746055655
                            </a>
                        </p>
                    </div>
                </div>

                {/* Right Section */}
                <div className="flex-1">
                    <div className="md:mt-16">
                        <h2 className="text-2xl font-semibold font-poppins">Media Sosial</h2>
                        <div className="flex gap-4">
                            <a href="https://www.instagram.com/lifemedia.id/" target="_blank" rel="noreferrer">
                                <img src={iconInstagram} alt="Instagram" className="w-6 h-6 md:w-12 md:h-12" />
                            </a>
                            <a href="https://www.facebook.com/profile.php?id=100064128426630" target="_blank" rel="noreferrer">
                                <img src={iconFacebook} alt="Facebook" className="w-6 h-6 md:w-12 md:h-12" />
                            </a>
                            <a href="https://www.tiktok.com/@lifemedia.id" target="_blank" rel="noreferrer">
                                <img src={iconTiktok} alt="Tiktok" className="w-6 h-6 md:w-12 md:h-12 bg-white p-1 rounded-lg" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
});

export default Footer;